export default "__VITE_ASSET__BNhyCheh__"